import React, { Component } from "react"
import { Helmet } from "react-helmet";
import Layout from "../components/layout";
import "../css/style.css";
import "../css/animate.min.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import downArrow from '../images/down-arrow.svg'
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper';
import ScrollAnimation from 'react-animate-on-scroll';
import { Animated } from "react-animated-css";
import PopupForm from "../components/popupForm";

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);
var accItem;
class AmericanDreamFaqSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 90000000
    }
  }

  handlePopupWindow = () => {
    this.setState({ time: Math.random() })
  }

  componentDidMount() {

    accItem = document.getElementsByClassName('accordionItem');
    let accHD = document.getElementsByClassName('accordionItemHeading');
    for (let i = 0; i < accHD.length; i++) {
      accHD[i].addEventListener('click', this.toggleItem, false);
    }
  }
  accorfn = () => {

    accItem = document.getElementsByClassName('accordionItem');
    let accHD = document.getElementsByClassName('accordionItemHeading');
    for (let i = 0; i < accHD.length; i++) {
      accHD[i].addEventListener('click', this.toggleItem, false);
    }

  }
  toggleItem() {

    var itemClass = this.parentNode.className;
    for (let i = 0; i < accItem.length; i++) {
      accItem[i].className = 'accordionItem close';
    }
    if (itemClass == 'accordionItem close') {
      this.parentNode.className = 'accordionItem open';
    }
  }

  render() {

    return (

      <div>
        <PopupForm time={this.state.time} />
          
          {/* <section class="faq-sec"> */}

            <Animated animationIn="fadeInUp" animationOut="fadeInDown" isVisible={true}>

              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <div id="american-dream-faq-inner" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".2s">

                      <div class="accordionWrapper">

                        <div id="american-dream-accordian" class="accordionItem open" onClick={() => this.accorfn()} >
                          <h2 class="accordionItemHeading" >What is the All American Year 1 Program? <span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>
                                All American Year 1 program is The WorldGrad’s online program through which students can complete their first year (30 credits) of a bachelor degree online and progress to a university in the US from year 2 and continue their education at university campuses.
                            </p>
                          </div>
                        </div>
                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">Will I get an admission offer from a US university?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>
                                Yes, after completion of your All American Year 1 program from home, you will receive 24 - 30 university credits issued by one of our partner universities in the US (Tiffin University & Mount Saint Mary’s University) which can be transferred to any university in the US including our pre-approved partners. Your admission offer will also depend on other university requirements like academic and IELTS scores.
                            </p>
                          </div>
                        </div>

                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading">Is the All American Year 1 program recognized by the US universities?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>
                                Yes. The credits you will earn over the course of the All American Year 1 program are transferable and issued by our program partners; Tiffin University and Mount Saint Mary’s University. These credits are recognized  and can be used to get admission into a university of your choice.
                            </p>
                          </div>
                        </div>

                        <div id="american-dream-accordian" class="accordionItem close" onclick={() => this.accorfn()}>
                          <h2 class="accordionItemHeading" >What are the fees of the All American Year 1 program?<span><img src={downArrow} alt="" /></span></h2>
                          <div class="accordionItemContent">
                            <p>
                                The fees for the All American Year 1 program is INR 7.5 lacs + GST.
                            </p>
                          </div>
                        </div>
                        
                      </div>
                      {/* <div class="enquire-btn">
                        <a class="btn btn-default" onClick={() => this.handlePopupWindow()}>Speak With Us</a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </Animated>
          {/* </section> */}
        {/* </Layout> */}
      </div>
    )
  }
}
export default AmericanDreamFaqSection;
